import { type FileWithStatus } from '@loadsmart/loadsmart-ui'

export function setFilesStatus(files: File[]): FileWithStatus[] {
  return files.map(file => ({ file, status: 'success' }))
}

function getFilesSize(files: File[]) {
  return files.reduce((partialFilesSize, currentFile) => {
    return partialFilesSize + currentFile.size
  }, 0)
}

export function validateFiles(files: File[]) {
  const sizeInBytes = getFilesSize(files)
  const fileSizeInMegabytes = sizeInBytes / 1000000

  if (files.length === 0 || fileSizeInMegabytes > 10) {
    throw new Error('You must attach up to 1 file with 10mb max.')
  }
}
